import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
// import { ActivatedRoute } from '@angular/router'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { DrugPlan } from '../../../models/drug-plan'
import { Notes } from '../../../models/notes'
import { PaymentOptions } from '../../../models/payment-options'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { Router } from '@angular/router'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { ValidatedCheckboxComponent } from '../../../../validations/validated-checkbox.component'
import { NumericTextFieldValidator } from '../../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { SubmitEnrollmentDataResponse } from '../../../models/submit-enrollment-data-response'
import { PortalGlobals } from '../../../../portalglobals'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import * as moment from 'moment'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { UtilsService } from '../../common/utils-service'
import { IndvRepComponent } from '../../common/indvrep.component'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'NEJESingleGroupStep3',
    templateUrl: 'single-group-step3.component.html'
})
export class NEJESingleGroupStep3Component implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    drugPlanModel = {} as DrugPlan
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    notesModel = {} as Notes
    isValidAgent: boolean
    isAuthRep: boolean
    selAuthorizedRep: string
    selrblMailCopy: string
    selectPlan: string
    selectedPlan: string
    paymentMethod: typeof PaymentOptions
    public rblAuthorizedRep: ValidatedRadioButtonModel[] = []
    public rblMailCopy: ValidatedRadioButtonModel[] = []
    rblRelation: ValidatedSelectOptionModel[] = []
    @Input() states: State[]
    numericTextFieldValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    phoneNumberInputMask = new PhoneNumberInputMask()
    showTermsButton: boolean
    hasError: boolean
    ErrorMessages: any[]
    public loading: boolean = false
    orgName: string
    hasIncompleteError: boolean
    disableEffectiveDate: boolean
    planYear2018: boolean
    public CurrentDate: string
    public EnrolleeSign: string
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    baseTitle: string
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    @ViewChild(IndvRepComponent, { static: true }) helpToEnrollee: IndvRepComponent
    constructor(
        private router: Router,
        private _indvRepComponent: IndvRepComponent,
        private _stateGateway: StateGateway,
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private utils: UtilsService,
        private titleService: Title
    ) {
        this.rblAuthorizedRep.push({ value: 'No', htmlLabel: 'No' }, { value: 'Yes', htmlLabel: 'Yes' })
        this.rblMailCopy.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.showTermsButton = true
        this.paymentMethod = {} as typeof PaymentOptions
        this.ErrorMessages = [] as any[]
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' },
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )
        // this.paymentMethod = {} as EnrollmentFormViewModel

        this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => (this.states = states))
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {
        this.planYear2018 = false
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Final Review')
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.orgName = this._global.currentUser.insuranceCompanyName
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()

        if (this.enrollment === null || this.enrollment === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
        }

        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.ISSTCOB = this.enrollmentCacheData.ISSTCOB
                        this.enrollment.SINGLEGRPNAME = this.enrollmentCacheData.GroupPlanName
                        this.enrollment.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                        this.enrollment.RBLLONGTERM = this.enrollmentCacheData.RBLLONGTERM
                        this.enrollment.ISSINGLEGROUP = this.enrollmentCacheData.ISSINGLEGROUP
                        this.enrollment.CHANNELID = this.enrollmentCacheData.CHANNELID

                        this.LoadData()

                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
            }
        } else {
            this.LoadData()
        }
    }

    LoadData(): void {
        this.disableEffectiveDate = false
        this.isAuthRep = false
        this.CurrentDate = moment().format('MM/DD/YYYY')
        // alert(this.paymentMethod.lastName)

        this.EnrolleeSign =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)
        if (this.enrollment !== undefined) {
            this.selectedPlan = this.enrollment.PLANNAME
            this.rblAuthorizedRepClick(this.enrollment.AUTHREPIND)
            if (this.enrollment.SUBMISSIONTYPECODE === 'INCOMPLETE') {
                this.showTermsButton = false
            } else {
                this.showTermsButton = true
            }
            this.helpToEnrollee.rblAppIndINDClick(this.enrollment.INDREPIND)
            this.helpToEnrollee.relToEnrollonValueChange(this.enrollment.RELTOENROLL)
        }
    }

    onSubmit(): void {
        this.isValidAgent = true
    }

    rblAuthorizedRepClick(event: any): void {
        if (event === 'Yes') {
            this.isAuthRep = true
        } else {
            this.isAuthRep = false
        }
        this.enrollment.AUTHREPIND = event
    }

    formSubmit(): void {
        if (!this.isFormInvalid()) {
            if (!this.isAuthRep) {
                this.enrollment.AUTHREPNAME = ''
                this.enrollment.AUTHREPPHONE = ''
                this.enrollment.AUTHREPREL = ''
                this.enrollment.AUTHREPADD1 = ''
                this.enrollment.AUTHREPCITY = ''
                this.enrollment.AUTHREPST = ''
                this.enrollment.AUTHREPZIP = ''
                this.enrollment.AUTHREPCOPYIND = ''
                this.enrollment.AUTHREPEMAIL = ''
                this.enrollment.AUTHREPSIGNEDIND = false
            }
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            let route = '/' + insCo + '/enrollment/neje/single-group/Step4'
            //  this.router.navigate([route])
            this.updateDataServiceCall(route)
        } else {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
    }
    isFormInvalid(): boolean {
        this.ErrorMessages = [] as any[]
        this.hasError = false
        if (!this.isAuthRep) {
            if (this.enrollment.APPSIGNEDIND === undefined || this.enrollment.APPSIGNEDIND === null || this.enrollment.APPSIGNEDIND === false) {
                this.ErrorMessages.push('Please check Beneficiary has signed application')
                this.hasError = true
            }
        }
        if (this.enrollment.AUTHREPIND === undefined || this.enrollment.AUTHREPIND === null || this.enrollment.AUTHREPIND === '') {
            this.ErrorMessages.push('Authorized Representative is required')
            this.hasError = true
        }

        if (this.isAuthRep) {
            if (this.enrollment.AUTHREPNAME === undefined || this.enrollment.AUTHREPNAME === '') {
                this.ErrorMessages.push('Authorized Representative  Name is required')
                this.hasError = true
            } else if (this.enrollment.AUTHREPNAME !== undefined && this.enrollment.AUTHREPNAME !== '' && this.enrollment.AUTHREPNAME !== null) {
                let checkAUTHREPNAME = this.enrollment.AUTHREPNAME
                let regexCityVal = /^[A-Za-z\s\-. ]+$/
                let isAUTHREPNAMEValid = regexCityVal.test(checkAUTHREPNAME)
                if (!isAUTHREPNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative  Name is invalid')
                }
            }
            if (this.enrollment.AUTHREPREL === undefined || this.enrollment.AUTHREPREL === '') {
                this.ErrorMessages.push('Authorized Representative  Relationship is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPPHONE === undefined || this.enrollment.AUTHREPPHONE === '') {
                this.ErrorMessages.push('Authorized Representative Phone is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPST === undefined || this.enrollment.AUTHREPST === '') {
                this.ErrorMessages.push('Authorized Representative  State is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPADD1 === undefined || this.enrollment.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Authorized Representative  Address is required')
                this.hasError = true
            }
            if (this.enrollment.AUTHREPCITY === undefined || this.enrollment.AUTHREPCITY === '') {
                this.ErrorMessages.push('Authorized Representative  City is required')
                this.hasError = true
            } else {
                let regexCityVal = /^[A-Za-z\s\-. ]+$/

                let isCityValid = regexCityVal.test(this.enrollment.AUTHREPCITY)
                if (!isCityValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid City')
                }
            }

            if (this.enrollment.AUTHREPZIP === undefined || this.enrollment.AUTHREPZIP === '') {
                this.ErrorMessages.push('Authorized Representative  Zip is required')
                this.hasError = true
            } else if (this.enrollment.AUTHREPZIP !== undefined && this.enrollment.AUTHREPZIP !== '' && this.enrollment.AUTHREPZIP !== null) {
                let checkZipCode = this.enrollment.AUTHREPZIP,
                    regexVal = new RegExp('[0-9]{5}')
                let isZipCodeValid = regexVal.test(checkZipCode)
                if (!isZipCodeValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Zip is invalid')
                }
            }
            if (this.enrollment.AUTHREPPHONE !== undefined && this.enrollment.AUTHREPPHONE !== '' && this.enrollment.AUTHREPPHONE !== null) {
                let checkOrgPhone = this.enrollment.AUTHREPPHONE.replace(/-/g, '')
                if (/^\d{10}$/.test(checkOrgPhone)) {
                } else {
                    if (!this.isValidNumber(checkOrgPhone)) {
                        this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                        this.hasError = true
                    } else {
                        this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                        this.hasError = true
                    }
                }
            }
            if (this.enrollment.AUTHREPEMAIL !== undefined && this.enrollment.AUTHREPEMAIL !== '') {
                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollment.AUTHREPEMAIL.toLowerCase()

                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid Email address for authorize representative')
                }
            }
            if (this.enrollment.AUTHREPSIGNEDIND === undefined || this.enrollment.AUTHREPSIGNEDIND === null || !this.enrollment.AUTHREPSIGNEDIND) {
                this.ErrorMessages.push('Please check Power of Attorney has signed application')
                this.hasError = true
            }
        }

        if (this.enrollment.INDREPIND === 'Yes') {
            if (this.enrollment.INDREPNAME === undefined || this.enrollment.INDREPNAME === null || this.enrollment.INDREPNAME == '') {
                this.ErrorMessages.push('Individual Rep Name is required')
                this.hasError = true
            }
            if (this.enrollment.RELTOENROLL === undefined || this.enrollment.RELTOENROLL === null || this.enrollment.RELTOENROLL == '') {
                this.ErrorMessages.push('Relationship to enrollee is required')
                this.hasError = true
            }
            if (
                (this.enrollment.displayRELTOENROLL == 'Agent' || this.enrollment.displayRELTOENROLL == 'Broker') &&
                (this.enrollment.NPN === undefined || this.enrollment.NPN === null || this.enrollment.NPN == '')
            ) {
                this.ErrorMessages.push('National Producer Number is required')
                this.hasError = true
            }
            if (
                this.enrollment.NPN != undefined &&
                this.enrollment.NPN != null &&
                this.enrollment.NPN != '' &&
                !this.utils.isValidNPN(this.enrollment.NPN)
            ) {
                this.ErrorMessages.push('Invalid NPN')
                this.hasError = true
            }
        }
        this.hasError = !!this.ErrorMessages.length

        return this.hasError
    }
    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    goBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step2'])
    }

    incompleteClick(): void {
        if (!this.incompleteClickValidation()) {
            this.enrollment.SUBMISSIONTYPECODE = 'INCOMPLETE'
            this.enrollment.PLANYEAR = String(this._global.selectedPlanYear)
            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            let route = 'enrollment/neje/single-group/Confirmation'
            //  this.router.navigate([route])
            this.updateDataServiceCall(route)
        } else {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
    }
    incompleteClickValidation(): boolean {
        this.ErrorMessages = [] as any[]
        this.hasIncompleteError = false

        if (this.isAuthRep) {
            if (this.enrollment.AUTHREPNAME === undefined || this.enrollment.AUTHREPNAME === '') {
                this.ErrorMessages.push('Authorized Representative  Name is required')
                this.hasIncompleteError = true
            } else if (this.enrollment.AUTHREPNAME !== undefined && this.enrollment.AUTHREPNAME !== '' && this.enrollment.AUTHREPNAME !== null) {
                let checkAUTHREPNAME = this.enrollment.AUTHREPNAME
                let regexCityVal = /^[A-Za-z\s\-. ]+$/
                let isAUTHREPNAMEValid = regexCityVal.test(checkAUTHREPNAME)
                if (!isAUTHREPNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative  Name is invalid')
                }
            }
            if (this.enrollment.AUTHREPREL === undefined || this.enrollment.AUTHREPREL === '') {
                this.ErrorMessages.push('Authorized Representative  Relationship is required')
                this.hasIncompleteError = true
            }
            if (this.enrollment.AUTHREPST === undefined || this.enrollment.AUTHREPST === '') {
                this.ErrorMessages.push('Authorized Representative  State is required')
                this.hasIncompleteError = true
            }
            if (this.enrollment.AUTHREPADD1 === undefined || this.enrollment.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Authorized Representative  Address is required')
                this.hasIncompleteError = true
            }
            if (this.enrollment.AUTHREPCITY === undefined || this.enrollment.AUTHREPCITY === '') {
                this.ErrorMessages.push('Authorized Representative  City is required')
                this.hasIncompleteError = true
            } else {
                let regexCityVal = /^[A-Za-z\s\- .]+$/

                let isCityValid = regexCityVal.test(this.enrollment.AUTHREPCITY)
                if (!isCityValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Please enter valid City')
                }
            }

            if (this.enrollment.AUTHREPZIP === undefined || this.enrollment.AUTHREPZIP === '') {
                this.ErrorMessages.push('Authorized Representative  Zip is required')
                this.hasIncompleteError = true
            } else if (this.enrollment.AUTHREPZIP !== undefined && this.enrollment.AUTHREPZIP !== '' && this.enrollment.AUTHREPZIP !== null) {
                let checkZipCode = this.enrollment.AUTHREPZIP,
                    regexVal = new RegExp('[0-9]{5}')
                let isZipCodeValid = regexVal.test(checkZipCode)
                if (!isZipCodeValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Zip is invalid')
                }
            }

            if (this.enrollment.AUTHREPPHONE !== undefined && this.enrollment.AUTHREPPHONE !== '' && this.enrollment.AUTHREPPHONE !== null) {
                let checkOrgPhone = this.enrollment.AUTHREPPHONE.replace(/-/g, '')
                if (/^\d{10}$/.test(checkOrgPhone)) {
                } else {
                    if (!this.isValidNumber(checkOrgPhone)) {
                        this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                        this.hasIncompleteError = true
                    } else {
                        this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                        this.hasIncompleteError = true
                    }
                }
            }
        }
        return this.hasIncompleteError
    }

    updateDataServiceCall(route: string) {
        if (this.enrollment.SUBMISSIONTYPECODE === 'INCOMPLETE') {
            this.enrollment.STEPCODE = '2'

            //Remove Data for the Individual
            if (!(this.enrollment.INDREPIND === 'Yes')) {
                this._indvRepComponent.selectedNo(this.enrollment)
            }

            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            //this.router.navigate([route])
            this.loading = true
            this._enrollementGateway.SubmitEnrollmentData(this.enrollment).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        } else {
                            if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                                this.enrollment.ENROLLKEY = response.EnrollmentKey
                                this.enrollment.CONF = response.confirmationNumber
                                this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                this.loading = false
                                this.router.navigate([route])
                            } else {
                                this.ErrorMessages.push('Error while submitting data, please try again.')
                                this.hasError = true
                                this.focusableEleTop.nativeElement.focus()
                            }
                        }
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                    }
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.loading = true
            this.enrollment.STEPCODE = '3'
            //            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            // this.router.navigate([route])
            this._enrollementGateway
                .validateZipForAll(this.enrollment.APPST, this.enrollment.APPZIP, '0', '0', this.enrollment.AUTHREPST, this.enrollment.AUTHREPZIP)
                .subscribe(
                    (model: string[]) => {
                        if (model !== undefined && model !== null && model.length !== 0) {
                            this.ErrorMessages = model
                            console.log(this.ErrorMessages)
                            this.hasError = true
                            window.scrollTo(0, 0)
                            this.loading = false
                        } else {
                            //Remove Data for the Individual
                            if (!(this.enrollment.INDREPIND === 'Yes')) {
                                this._indvRepComponent.selectedNo(this.enrollment)
                            }
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

                            this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
                                (model: SubmitEnrollmentDataResponse) => {
                                    this.loading = true
                                    let response = model
                                    if (response !== undefined) {
                                        if (response.Errors !== undefined && response.Errors.length > 0) {
                                            this.hasError = true

                                            for (let i = 0; i < response.Errors.length; i++) {
                                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                            }
                                            this.focusableEleTop.nativeElement.focus()
                                        } else {
                                            //this.enrollment.ENROLLKEY = response.EnrollmentKey
                                            //this.enrollment.CONF = response.confirmationNumber
                                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                            this.router.navigate([route])
                                        }
                                    } else {
                                        this.ErrorMessages.push('Error while submitting data, please try again.')
                                        this.focusableEleTop.nativeElement.focus()
                                    }
                                },
                                (err) => {
                                    this.loading = false
                                }
                            )
                        }
                    },
                    (err) => {
                        this.loading = false
                    }
                )
        }
    }

    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
}
